import { t } from 'i18next';
import { validnumberregex, MAX_TRACKING_NUMBERS } from './constants';

const isTrackNumberValid = (v) => v.match(/^[a-z0-9\s]+[-.]?[a-z0-9\s]*$/gi);
const isTrackNumberInvalid = (v) => !isTrackNumberValid(v);
const isReferenceNumberValidEx = (v) => v.match(/^[a-z0-9\s\-\\/]+$/gi);
const isValidShipmentNumber = (v) => v.match(/^[a-z0-9\s]+[-.]?[a-z0-9\s]*$/i);

export const isGroupOfShipmentNumbersValid = (value) => {
  if (value) {
    const group = value
      .split(validnumberregex)
      .map((number) => (number ? number.trim() : undefined))
      .filter(Boolean);

    const invalidNumbers = group.filter((number) => !isValidShipmentNumber(number));
    if (invalidNumbers.length > 0) return t('ErrorSpecialCharacters');

    if (group.length === 0 || group.length > MAX_TRACKING_NUMBERS) {
      return t('TrackShipment_ShipmentNumbersNotInRange', { num: MAX_TRACKING_NUMBERS });
    }
  }

  return undefined;
};

export const maxLength = (max) => (value) => (value && value.length > max ? t('MustBeEqualOrLessChar', { max }) : undefined);

export const maxChar40 = maxLength(40);

export const isReferenceNumberValid = (value) => {
  if (isReferenceNumberValidEx(value)) {
    return undefined;
  }

  return t('TrackShipment_CheckForTypos');
};

export const isZipPostalCodeValid = (value) => {
  if (!value) { return undefined; }

  if (isTrackNumberValid(value)) {
    return undefined;
  }

  return t('InvalidPostalOrZipCode');
};

export const validateForm = (values) => {
  const errors = {};

  if (values.shipmentNumbers) {
    const numbers = values.shipmentNumbers
      .split(validnumberregex)
      .map((num) => (num ? num.trim() : undefined))
      .filter(Boolean);

    const invalidnumbers = numbers.filter((n) => n && isTrackNumberInvalid(n));
    if (invalidnumbers.length > 0) {
      errors.shipmentNumbers = t('TrackShipment_CheckForTypos');
    }

    if (numbers.length === 0 || numbers.length > MAX_TRACKING_NUMBERS) {
      errors.shipmentNumbers = t('TrackShipment_ShipmentNumbersNotInRange', { num: MAX_TRACKING_NUMBERS });
    }
  } else if (values.orderNumbers) {
    const numbers = values.orderNumbers.split(validnumberregex).filter(Boolean);

    const invalidnumbers = numbers.filter(isTrackNumberInvalid);

    if (invalidnumbers.length > 0) {
      errors.orderNumbers = t('TrackShipment_CheckForTypos');
    }

    if (numbers.length === 0 || numbers.length > 20) {
      errors.orderNumbers = t('TrackShipment_OrderNumbersNotInRange');
    }
  }

  return errors;
};
